<template>
  <div v-if="library && library.length" class="attachment-count">
    <div class="attachment-count__trigger">
      <img class="attachment-count__icon" src="@/assets/icons/attachment.svg" alt="Attachment" />
      <img class="attachment-count__icon-hover" src="@/assets/icons/attachment-dark.svg" alt="Attachment" />
      <div class="val" v-text="library.length" />
    </div>

    <div class="attachment-count__content">
      <div class="attachment-count__content-item" v-for="(item, i) in library" :key="i">
        <div class="attachment-count__content-name" v-text="item.name" />
        <a
          class="attachment-count__content-link"
          :href="`${item.file}`"
          @click="handleClickLink"
          target="_blank"
        >
          <span>{{ $t('events.attachment.view') }}</span>
          <img src="@/assets/icons/arrow-r-dark.svg" alt="" />
        </a>
      </div>
    </div>
  </div>
  <div v-else class="attachment-count__empty"></div>
</template>

<script>
export default {
  name: 'AttachmentCount',
  props: {
    library: Array,
  },
  methods: {
    handleClickLink() {
      this.$root.sendSignal({ ext_link: this.data.file })
    },
  }
}
</script>

<style lang="scss">
.attachment-count {
  text-decoration: none;

  &__empty {
    width: 48px;
  }

  &__trigger {
    display: flex;
    align-items: center;
    margin-right: 12px;
    font-weight: 400;
    font-size: 15px;
    line-height: 125%;
    color: $text;
    cursor: pointer;
  }

  img {
    margin-right: 7px;
  }

  &__icon-hover {
    display: none;
  }

  &__content {
    display: none;
    position: absolute;
    z-index: 2;
    top: 8px;
    left: 15px;
    right: 15px;
    bottom: 67px;

    overflow: auto;
    padding: 20px;
    background: #ffffff;
    border-radius: 13px;
    box-shadow: 0 12px 21px rgba(204, 215, 230, 0.19);

    &-item {
      & + & {
        margin-top: 26px;
      }
    }

    &-name {
      word-break: break-all;
    }

    &-title {
      font-weight: 400;
      font-size: 15px;
      line-height: 157.5%;

      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      max-height: 15px;

      margin-bottom: 2px;
    }

    &-link {
      display: inline-flex;
      align-items: center;
      font-weight: 700;
      font-size: 12px;
      line-height: 147.5%;
      color: #003882;

      img {
        margin-left: 6px;
      }
    }
  }

  &:hover {
    .attachment-count__icon {
      display: none;
    }

    .attachment-count__icon-hover {
      display: block;
    }
    .attachment-count__content {
      display: block;
    }

    &::after {
      content: '';
      display: block;
      position: absolute;
      cursor: pointer;
      left: 130px;
      right: 60px;
      bottom: 30px;
      height: 40px;
    }
  }
}
</style>
